import { ecommerce } from '@uds/tagmg';
import { selectors as productSelectors } from '@uds/product';
import { GetProductData } from 'core/cta';
import { getLanguageCookie } from 'domain/selectors/common';

const sendProductClicked = ({
  productId,
  list,
  getProductData,
}: {
  list: string;
  productId?: string | null;
  getProductData: GetProductData;
}) => {
  const locale = getLanguageCookie();

  if (!productId) {
    return;
  }
  return getProductData({
    skuId: productId,
    locale,
  }).then((product) => {
    const id = product?.id;
    const name = product?.name;
    let price = 0;
    // in case we ever get a malformed product, getPrice would throw an error
    try {
      price = productSelectors.getPrice({
        product,
        includeTax: false,
      });
    } catch (e) {
      return;
    }

    ecommerce([
      [
        'addProduct',
        {
          id: `${id}`,
          name,
          price,
        },
      ],
      ['setAction', 'click', { list }],
    ]);
  });
};

export default sendProductClicked;
